import env from 'Env';

/**
 * Convert user reviewSummary into google structured data
 * @param  {Array.Object} reviewSummary
 * @param  {Object}       product
 * @return {Array.Object|undefined}
 */
export default function reviewStructuredData(reviewSummary, product) {
  if (!reviewSummary || !reviewSummary.total_ratings) {
    return undefined;
  }

  const productUrl = `https://${env.appUrl}/${window.locale || 'en'}/${product.type || 'game'}/${product.slug}`;

  return {
    '@type': 'AggregateRating',
    '@id': `${productUrl}#aggregaterating`,
    ratingValue: reviewSummary.rating_score,
    description: 'User Reviews',
    bestRating: 5,
    worstRating: 1,
    ratingCount: reviewSummary.total_ratings,
    reviewCount: reviewSummary.total_written_reviews || 1,
  };
}
